"use strict";

exports.__esModule = true;
exports["default"] = void 0; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Method
// ----------------------------------------------------------------------------

/** */

var smallKey = function smallKey() {
  return "" + Math.random().toString(36).substring(7);
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------


var _default = smallKey;
exports["default"] = _default;
module.exports = exports.default;